// extracted by mini-css-extract-plugin
export var activityContainer = "_h1-0";
export var typingIndicatorContainer = "_h1-1";
export var typingIndicatorDot = "_h1-2";
export var wave = "_h1-3";